var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CreditCardPlanSelector',_vm._b({model:{value:(_vm.iValue),callback:function ($$v) {_vm.iValue=$$v},expression:"iValue"}},'CreditCardPlanSelector',{
		plansGroups: _vm.selector.checkoutData.plansGroups,
		currencySign: _vm.checkout.order.currency.sign,
		selectable: true,
	},false))}
var staticRenderFns = []

export { render, staticRenderFns }